<template>
  <div class="AdminUsers container-fluid">
    <Navigation showPromoterNav="true"></Navigation>
    <table class="table userTable">
      <tbody>
        <tr v-for="user in users" v-bind:class="{unconfirmed: !user.confirmed}">
          <td>{{user.type}}</td>
          <td>{{user.username}}</td>
          <td v-if="user.type !=='promoter'">{{user.firstName}}</td>
          <td v-if="user.type ==='promoter'">
            <span v-if="typeof user.promoter !== 'undefined'"> {{user.promoter.data.companyName}}</span>
          </td>
          <td v-if="user.type !=='promoter'">{{user.lastName}}</td>
          <td v-if="user.type ==='promoter'">
            <span v-if="typeof user.promoter !== 'undefined'"> {{user.promoter.data.rnaatNumber}}</span>
          </td>
          <td>{{user.email}}</td>
        <td>
          <button class="btn btn-sm btn-success" @click="approveUser({id: user.id, approved: true})" v-if="!user.approved">aprovar</button>
          <button class="btn btn-sm btn-danger" @click="approveUser({id: user.id, approved: false})" v-if="user.approved">desaprovar</button>
          <button class="btn btn-sm btn-success" @click="loginAs(user.username)">login</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';
import Navigation from '../Admin/Navigation/Navigation';

export default {
  name: 'AdminUsers',
  components: {
    Navigation,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({
      approveUser: 'AdminApproveUser',
    }),
    loginAs(username) {
      this.$store.dispatch('AdminLoginAsUser', username);
    },
  },
  computed: {
    ...mapState({
      users: state => state.adminUsers.users,
      language: state => state.language,
    }),
  },
  created() {
    this.$store.dispatch('adminGetUsers');
  },
};
</script>

<style lang="scss" scoped>
.AdminUsers {
  padding-top: 120px;
  padding-bottom: 100px;
  min-height: 100vh;
}
tr {
  //background-color: #bbdefb;
}
.unconfirmed {
  background-color: #ffcdd2;
}

</style>



// WEBPACK FOOTER //
// AdminUsers.vue?58a34b5e